import globalToast from '$$vueCmp/toast';

class CopyPaste {
  #instance = null;

  init(instance) {
    this.#instance = instance;
  }

  pasteValidation() {
    const copiedTask = this.#instance.ganttDataApi.getCopiedTask();
    const sameProject = copiedTask.ganttId === this.#instance.config.gantt_id;
    const taskNotExist = !this.#instance.isTaskExists(copiedTask.taskId);

    if ((sameProject && taskNotExist) && copiedTask) {
      this.#instance.ganttDataApi.setCopyPasteError({ taskIds: [+copiedTask.taskId], text: 'can_not_copy_delete' });
    }

    const copyPastError = this.#instance.ganttDataApi.getCopyPastError();

    if (!copyPastError) {
      return true;
    }

    globalToast.error(__(copyPastError), { timeout: 6000 });

    return false;
  }

  copy(taskId) {
    this.#instance.ganttDataApi.copyTask(+taskId);
  }

  async paste(taskId, mode) {
    // mode = 'paste_task_above' | 'paste_task_below'
    const before = mode === 'paste_task_above';

    await this.#instance.ganttDataApi.pasteTask({ before, taskId });

    const copiedTask = this.#instance.ganttDataApi.getCopiedTask();
    const totalTask = this.#instance.getTaskByIndex(0);

    this.#instance.ganttDataApi.setCopyPasteError({ taskIds: [+copiedTask.parentId, +totalTask.id], text: 'can_not_copy_changes' });
  }
}

export default new CopyPaste();
